export const navigation = {
  dashboard: () => {
    return "/dashboard";
  },
  dashboardNotFound: () => {
    return "/dashboard/not-found";
  },
  login: (searchParams?: URLSearchParams) => {
    return `/login${searchParams ? `?${searchParams.toString()}` : ""}`;
  },
  createAccount: () => {
    return "/create-account";
  },
  chromeExtensionWaitingRoom: () => {
    return "/dashboard/chrome-extension-waiting-room";
  },
  account: () => {
    return "/dashboard/account";
  },
  billing: () => {
    return "/dashboard/billing";
  },
  patients: () => {
    return "/dashboard/patients";
  },
  logout: () => {
    return "/dashboard/logout";
  },
  patientDetail: (patientId: string) => {
    return `${navigation.patients()}/${patientId}`;
  },
  patientBriefing: (patientId: string) => {
    return `${navigation.patientDetail(patientId)}/briefing`;
  },
  patientToday: (patientId: string) => {
    return `${navigation.patientDetail(patientId)}/today`;
  },
  patientEncounters: (patientId: string) => {
    return `${navigation.patientDetail(patientId)}/encounters`;
  },
  patientEncounter: (patientId: string, encounterId: string) => {
    return `${navigation.patientDetail(patientId)}/encounter/${encounterId}`;
  },
};
